module.exports = __webpack_public_path__ + "img/7.adeb872d.jpg";